module.exports = __webpack_public_path__ + "static/img/service-4.bddd5b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/service-4.png
// module id = ykc/
// module chunks = 1